module.exports = __webpack_public_path__ + "static/media/2ATH3BK.crop-twitter.d57630a2.jpg";